import { reactive, ref, watch } from 'vue';
import type { TeamAthlete, TeamAthleteProfile, MinimalAthleteForPosition } from '@/types/athletes';

export interface UseChangeAcademicYearDialogState {
  isOpen: boolean;
  athlete: MinimalAthleteForPosition | TeamAthlete | TeamAthleteProfile | null;
  currentAcademicYearIds: string[];
  prefillAcademicYearIds: string[];
}

const DEFAULT_STATE: UseChangeAcademicYearDialogState = {
  isOpen: false,
  athlete: null,
  currentAcademicYearIds: [],
  prefillAcademicYearIds: [],
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseChangeAcademicYearDialogState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useChangeAcademicYearDialog() {
  async function open(
    athlete: TeamAthlete | TeamAthleteProfile | MinimalAthleteForPosition,
    currentAcademicYearIds: string[] = [],
    prefillAcademicYearIds: string[] = [],
  ) {
    state.athlete = athlete;
    state.currentAcademicYearIds = currentAcademicYearIds;
    state.prefillAcademicYearIds = prefillAcademicYearIds;
    state.isOpen = true;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
